// 静态选项与常量：从 StationAddStepDevice.vue 抽出
// 全部为不可变数据 / 无副作用的 label 查询函数

/** 电表类型选项（v-select items） */
export const meterTypeOptions = [
  { title: '关口电表', value: 1 },
  { title: '并网电表', value: 3 },
  { title: '负载电表', value: 4 },
  { title: '光伏电表', value: 5 },
]

/**
 * meterType → UUID 段位 code + 反查正则。
 * UUID 规范：S{stationId}_{code}{order}
 */
export const meterUuidConfigMap = {
  1: { code: 'PCC', pattern: /^S\d+_PCC(\d+)$/i },
  3: { code: 'GCP', pattern: /^S\d+_GCP(\d+)$/i },
  4: { code: 'LOAD', pattern: /^S\d+_LOAD(\d+)$/i },
  5: { code: 'PV', pattern: /^S\d+_PV(\d+)$/i },
}

export function meterTypeLabel(v) {
  const found = meterTypeOptions.find((o) => o.value === Number(v))
  return found?.title ?? '—'
}

/** 电表生产地点选项（值为字符串"0"/"1"） */
export const productLocationOptions = [
  { title: '箱变并网柜', value: '0' },
  { title: '储能并网柜', value: '1' },
]

export function productLocationLabel(v) {
  const found = productLocationOptions.find((o) => o.value === String(v))
  return found?.title ?? ((v ?? '').toString().trim() || '—')
}

/** eLink 型号候选（当前仅 eLink3000；后端接入前保持静态） */
export const elinkModelOptions = [
  { title: 'eLink3000', value: 'eLink3000' },
]

/** 集中式电站的 eBlock 型号判定正则（以 Galaxy 开头） */
export const galaxyModelPattern = /^Galaxy/i

/** 充电桩充电模式选项 */
export const pileChargeModeOptions = [
  { title: '快充', value: 1 },
  { title: '慢充', value: 2 },
]

export function pileChargeModeLabel(v) {
  const found = pileChargeModeOptions.find((o) => o.value === Number(v))
  return found?.title ?? '—'
}
